import _classCallCheck from "/Users/SrinivasTamada/Desktop/projects/react-ionic-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/SrinivasTamada/Desktop/projects/react-ionic-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/SrinivasTamada/Desktop/projects/react-ionic-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/SrinivasTamada/Desktop/projects/react-ionic-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/SrinivasTamada/Desktop/projects/react-ionic-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import ReactDOM from 'react-dom';
import { dashToPascalCase, attachEventProps } from './utils';
export function createReactComponent(tagName) {
  var displayName = dashToPascalCase(tagName);

  var ReactComponent =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(ReactComponent, _React$Component);

    function ReactComponent(props) {
      var _this;

      _classCallCheck(this, ReactComponent);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactComponent).call(this, props));
      _this.componentRef = React.createRef();
      return _this;
    }

    _createClass(ReactComponent, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.componentWillReceiveProps(this.props);
      }
    }, {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(props) {
        var node = ReactDOM.findDOMNode(this);
        attachEventProps(node, props);
      }
    }, {
      key: "render",
      value: function render() {
        var _a = this.props,
            children = _a.children,
            forwardedRef = _a.forwardedRef,
            cProps = __rest(_a, ["children", "forwardedRef"]);

        return React.createElement(tagName, Object.assign({}, cProps, {
          ref: forwardedRef
        }), children);
      }
    }], [{
      key: "displayName",
      get: function get() {
        return displayName;
      }
    }]);

    return ReactComponent;
  }(React.Component);

  function forwardRef(props, ref) {
    return React.createElement(ReactComponent, Object.assign({}, props, {
      forwardedRef: ref
    }));
  }

  forwardRef.displayName = displayName;
  return React.forwardRef(forwardRef);
}